// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__fd7vZ","rightAdornment":"Header_rightAdornment__2TEK2"};